import {Box, HStack, Icon, Text} from 'platform/foundation';

import {isNil} from 'ramda';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {EquipmentDocument} from '../../../api/digitalCertificateApi';
import {Link} from '../../../components/Link/Link';
import {i18n} from '../../../i18n/i18n';

interface EquipmentDocumentDownloadProps extends TestIdProps {
  equipmentDocument: EquipmentDocument | Nullish;
}

/**
 * Download action for the inspection's equipment PDF. Rendered only when the certificate carries
 * an attachment; the link is the signed storage URL from the latest certificate response.
 */
export function EquipmentDocumentDownload(props: EquipmentDocumentDownloadProps) {
  if (isNil(props.equipmentDocument)) {
    return null;
  }

  return (
    <Box
      padding={[3, 4, 4, 4]}
      borderRadius="small"
      backgroundColor="fill.greyLight"
      data-testid={suffixTestId('equipmentDocument', props)}
    >
      <HStack spacing={3} align="center" justify="space-between" wrap>
        <HStack spacing={3} align="center">
          <Icon value="download" size={5} color="accent.base" />
          <Text size="small">{props.equipmentDocument.fileName}</Text>
        </HStack>
        <Link
          size="small"
          href={props.equipmentDocument.downloadUrl}
          target="_blank"
          rel="noreferrer"
          title={i18n.t('downloadEquipmentPDF')}
          data-testid={suffixTestId('equipmentDocumentDownload', props)}
        />
      </HStack>
    </Box>
  );
}
